import { useContext, useEffect } from "react";
import Select from "common/Select/Select";
import Text from "common/Typography/Text";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { formatTimeoutDisplay } from "@shared/features/bots/utils";
import { useTheme } from "styled-components";
import { FormFieldTitle } from "features/tradingTerminal/common/styles";

const StopTimeout = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const { t: tCommon } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { isNewLook } = useTheme();
  const {
    account,
    getCreateTradeGeneralDataQuery,
    stopTimeout,
    setStopTimeout,
    setValuesModified,
  } = useContext(TradingTerminalContext)!;
  const stopTimeoutData =
    getCreateTradeGeneralDataQuery.currentData?.data.general.options.find(
      ([name]) => name === "Stop Timeout"
    );
  const defaultStopTimeout = stopTimeoutData?.[2] ?? 0;

  useEffect(() => {
    setStopTimeout(defaultStopTimeout);
  }, [account?.client_id, defaultStopTimeout, setStopTimeout]);

  const onChange = (value: number) => {
    setStopTimeout(value);
    setValuesModified(true);
  };

  return (
    <div style={{ marginBottom: isNewLook ? 16 : 20 }}>
      {isNewLook ? (
        <FormFieldTitle>{t("labels.stop_timeout")}</FormFieldTitle>
      ) : (
        <Text style={{ display: "block", marginBottom: 8 }}>
          {t("labels.stop_timeout")}
        </Text>
      )}
      <Select<number>
        value={stopTimeout}
        onChange={onChange}
        options={stopTimeoutData?.[1].map((option) => ({
          value: option.value as number,
          label: formatTimeoutDisplay(Number(option.value) * 60, tCommon),
        }))}
        mobileTitle={t("labels.stop_timeout")}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default StopTimeout;
